import servise from '@/router/axios'

export const addSlot = (data) => {
  return servise({
    url: '/slot/add/channel',
    method: 'post',
    data
  })
}

export const updateSlot = (data) => {
  return servise({
    url: '/slot/channel',
    method: 'PUT',
    data
  })
}
